/*
 * Copyright (c) 2024 metromorph softworks GmbH
 *
 * All rights reserved
 */

declare global {
    interface Window { DEVELOPMENT: boolean | string | undefined; }
}

import * as React from "react";
import { createRoot } from "react-dom/client";

import { createBrowserHistory } from "history";

import { init } from "./i18n";

import App from "./App";

import "./screens";

init();

const rootElement = document.getElementById("root");
if (rootElement === null) {
    // TODO: Display a message to the user that the root element is missing
    throw new Error("Root element not found");
}

const history = createBrowserHistory();

createRoot(rootElement).render(
    <App
        history={history}
    />
);

new EventSource("/esbuild").addEventListener("change", () => location.reload());
